import { type ReactNode, useRef } from "react";
import { enqueue, ROOT_TARGET, type UploadTarget } from "../lib/uploads.ts";
import ui from "./ui.module.css";

type Props = {
  target?: UploadTarget;
  className?: string;
  variant?: "primary" | "ghost";
  label: string;
  children: ReactNode;
  compact?: boolean;
};

export function PickFiles({
  target = ROOT_TARGET,
  className,
  variant,
  label,
  children,
  compact,
}: Props) {
  const input = useRef<HTMLInputElement>(null);
  const multiple = target.kind === "new";

  return (
    <>
      <button
        type="button"
        className={`${compact ? ui.iconButton : ui.button} ${className ?? ""}`}
        data-variant={variant}
        onClick={() => input.current?.click()}
        aria-label={compact ? label : undefined}
        title={compact ? label : undefined}
      >
        {children}
      </button>
      <input
        ref={input}
        type="file"
        multiple={multiple}
        className={ui.visuallyHidden}
        tabIndex={-1}
        aria-hidden="true"
        data-upload={target.kind}
        onChange={(event) => {
          const files = event.currentTarget.files;
          if (files) enqueue([...files], target);
          event.currentTarget.value = "";
        }}
      />
    </>
  );
}
